"use client";
import { IconPositions } from "@/baseComponents";
import { Button } from "@/components/atoms/button";
import { CustomGrid } from "@/components/layout/grid";
import { ContactModal } from "@/components/molecules/contactModal";
import { HeaderSidebar } from "@/components/molecules/headerSidebar";
import {
  FundsDetailHeader,
  FundsHeaderProps,
} from "@/components/organisms/fundsDetailHeader";
import { chakra, GridItem, useDisclosure } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { LuMessageSquare } from "react-icons/lu";

export default chakra(FundsDetailPage);
function FundsDetailPage({
  header,
  contentBlocks,
  portfolioHighlights,
}: {
  header: FundsHeaderProps;
  contentBlocks: JSX.Element;
  portfolioHighlights: JSX.Element;
}) {
  const t = useTranslations();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <CustomGrid mb={{ base: 12, lg: 32 }}>
        <Button
          onClick={onOpen}
          buttonProps={{
            display: { base: "block", lg: "none" },
            position: "fixed",
            bottom: 4,
            right: 5,
            px: 5,
            py: 3,
            zIndex: "sticky",
          }}
          text={t("funds Contact Button")}
          icon={<LuMessageSquare />}
          iconPosition={IconPositions.Left}
        />
        <ContactModal
          display={{ base: "block", lg: "none" }}
          isOpen={isOpen}
          onClose={onClose}
          contactTitle={header.contactTitle}
          contactSubtitle={header.contactSubtitle}
          contactDetails={header.contactDetails}
        />
        <GridItem
          display={{ base: "none", lg: "flex" }}
          colSpan={{ lg: 4, xl: 3 }}
          position="sticky"
          top={20}
          alignSelf="flex-start"
        >
          <HeaderSidebar
            title={header.title}
            openForInvestment={header.openForInvestment}
            tags={header.tags}
            contactTitle={header.contactTitle}
            contactSubtitle={header.contactSubtitle}
            contactDetails={header.contactDetails}
          />
        </GridItem>

        <GridItem
          colStart={{ base: 1, lg: 5, xl: 4 }}
          colSpan={{ base: 12, lg: 8, xl: 9 }}
          display="flex"
          flexDirection="column"
          gap={{ base: 12, lg: 28 }}
        >
          <FundsDetailHeader
            title={header.title}
            mediaData={header.mediaData}
            intro={header.intro}
            openForInvestment={header.openForInvestment}
            tags={header.tags}
            features={header.features}
            detailPoints={header.detailPoints}
            keyPoints={header.keyPoints}
          />
          {contentBlocks}
        </GridItem>
      </CustomGrid>
      {portfolioHighlights}
    </>
  );
}
